<template>
  <div>
    <transition name="fade">
      <div class="out" v-if="showModal">
        <div class="common-small-dialog-wrap">
          <div class="common-small-dialog-content">
            <div class="dialog-center-bg"></div>
            <div class="dialog-close-btn" @click="close()"></div>
            <div class="dialog-header">
              <div>{{ title }}</div>
            </div>
            <div class="qrcode-content">
              <img :src="url" style="width: 122px; height: 122px;">
            </div>
            <div class="dialog-footer"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/style/modal.scss";

.qrcode-content {
  width: 35.48 * 4.2px;
  height: 35.48 * 4.2px;
  background: #032E69;
  border-radius: 4px;
  border: 1px solid #70C8FF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;

  @media (max-width: 550px) {
    width: 35.48vw;
    height: 35.48vw;
  }
}

.out {
  width: 100%;
  // max-width: 525px;
  height: 100vh;
  transform: translateX(-50%);
  position: fixed;
  left: 50%;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;

  @media (max-width: 550px) {
    width: 100%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}

.common-small-dialog-wrap {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.backpack-page .buy-back-dialog .buy-box img {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
}

.backpack-page .buy-back-dialog .cancel-btn {
  margin-right: 5.33 * 4.2px;
}

.backpack-page .buy-back-dialog,
.backpack-page .password-dialog,
.backpack-page .link-dialog,
.backpack-page .tips-dialog {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.backpack-page .buy-back-dialog .sure-btn,
.backpack-page .password-dialog .sure-btn,
.backpack-page .link-dialog .sure-btn,
.backpack-page .tips-dialog .sure-btn,
.backpack-page .buy-back-dialog .cancel-btn,
.backpack-page .password-dialog .cancel-btn,
.backpack-page .link-dialog .cancel-btn,
.backpack-page .tips-dialog .cancel-btn {
  width: 28.67 * 4.2px;
  height: 8 * 4.2px;
  background-size: 28.67 * 4.2px 8 * 4.2px;
  text-align: center;
  line-height: 8 * 4.2px;
}

.backpack-page .buy-back-dialog .sure-btn,
.backpack-page .password-dialog .sure-btn,
.backpack-page .link-dialog .sure-btn,
.backpack-page .tips-dialog .sure-btn {
  margin-top: 4 * 4.2px;
  background: url("../../assets/images/submit_btn.png") no-repeat 0 0;
  background-size: contain;

  width: 26.67 * 4.2px;
  height: 10 * 4.2px;
  line-height: 10 * 4.2px;
}

.backpack-page .buy-back-dialog .cancel-btn,
.backpack-page .password-dialog .cancel-btn,
.backpack-page .link-dialog .cancel-btn,
.backpack-page .tips-dialog .cancel-btn {
  margin-top: 4 * 4.2px;
  background: url("../../assets/images/del_confirm_btn.png") no-repeat 0 0;
  background-size: contain;

  width: 26.67 * 4.2px;
  height: 10 * 4.2px;
  line-height: 10 * 4.2px;
}

.btn-group {
  position: absolute;
  bottom: -80px;
}
</style>